import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { personName } from './validators/person-name-validator';
import { mobile } from './validators/mobile-validator';
import { mobileOrLandline } from './validators/mobile-or-landline-validator';
import { email } from './validators/email-validator';
import { requiredIf } from './validators/required-if-validator';
import { isPresent } from './utils/is-present';
import { getAllErrors } from './utils/get-all-errors';
import { FormDebugComponent } from './components/form-debug/form-debug.component';
import { accountNumber } from './validators/account-number-validator';
import { postCode } from './validators/post-code-validator';
import { addressLine1 } from './validators/address-validator';


export const CustomValidators = {
  personName,
  mobile,
  mobileOrLandline,
  email,
  requiredIf,
  accountNumber,
  postCode,
  addressLine1
};

export const Utils = {
  isPresent,
  getAllErrors,
};

@NgModule({
  declarations: [FormDebugComponent],
  imports: [CommonModule],
  exports: [FormDebugComponent],
})
export class FormsModule {}
